<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ReferralProgramBlockContentHolder',
})
</script>

<template>
    <div class="contentBox">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <div class="text">
                <p>У нас действует <span class="highlighted">реферальная программа</span>.</p>
                <p>После приобретения пропуска ты получишь письмо, в котором найдёшь персональную <span class="highlighted">реферальную ссылку</span>.</p>
                <p>Когда кто-нибудь покупает пропуск, используя эту ссылку, он становится твоим рефералом. Ты будешь получать бонусную игровую валюту - <span class="gc">галакоины</span> - за каждого нового реферала. Размер бонуса составляет 25% от суммы галакоинов, обеспечиваемой пропуском реферала.</p>
                <p>К примеру, если человек воспользуется твоей ссылкой, чтобы купить пропуск <span class="cmb_radiation">«Реликтовое излучение»</span>, ты получишь <span class="gc">750 галакоинов</span> (то есть 25% от 3000 галакоинов, которые полагаются рефералу за покупку этого пропуска).</p>
                <p>А ещё раз в две недели мы разыгрываем дополнительные призы среди тех, по чьей ссылке зарегистрируется больше участников.</p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;
    width: 100%;
    max-width: 700px;
    background: rgba(15, 15, 15, 0.85);
    border-radius: 20px 20px 30px 30px;
    box-shadow: 0 0 20px 5px rgba(20, 20, 20, 1.0);

    background-image: v-bind('`url("/img/page/landing/main/bg/8.webp")`');
    background-size: cover;
    background-position: center center;
}

.contentHolder {
    width: 100%;
    padding: 20px 15px 25px 15px;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: center;
    align-items: center;
}


.text {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    box-shadow: 0 0 10px 2px black;
    padding: 5px 10px 5px 10px;
    color: white;
}

p {
    //text-shadow: 0 0 3px rgba(0, 0, 0, 0.9);
    margin-bottom: 7px;
}

ul {
    margin: 0;
}

span {
    &.highlighted {
        color: orange;
    }
}
</style>
